import styled from 'styled-components';

import { boxShadow1, green, lightGray } from 'utils/style/colors';
import Icon from 'components/Icon';

interface IInputContainerProps {
  focused: boolean;
}

interface IChipProps {
  selected: boolean;
  disabled: boolean;
}
interface IChipsInputProps {
  placeholderColor?: string;
}

interface IWrapperProps {
  loading?: boolean;
}

export const Wrapper = styled('div')<IWrapperProps>`
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  transition: all 0.3s ease-in;
  ${({ loading }) =>
    loading &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const InputContainer = styled('div')<IInputContainerProps>`
  flex: 1;
  padding: 0.3rem;
  min-height: 35px;
  outline: none;
  transition: all 0.3s;
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => (props.focused ? green : 'var(--gray)')};
  box-shadow: ${(props) =>
    props.focused ? '0 0 0 2px rgba(50, 200, 182, 0.3)' : 'none'};
  border-radius: 10px;
  background-color: white;
  box-sizing: border-box;
  &:hover {
    border-color: ${green};
  }
  overflow: auto hidden;
  //height: 49px;
`;

export const ChipsInput = styled('input')<IChipsInputProps>`
  background: none;
  border: 0;
  color: rgba(0, 0, 0, 0.6);
  display: inline-block;
  font-size: 1rem;
  height: 2rem;
  line-height: 2rem;
  outline: 0;
  padding: 0 !important;
  max-width: 12rem !important;
  margin: 3px;
  ::placeholder {
    color: ${({ placeholderColor }) => placeholderColor};
  }
`;

export const Chip = styled('span')<IChipProps>`
  display: inline-flex;
  font-size: 0.8rem;
  align-items: center;
  font-weight: 500;
  line-height: 2rem;
  padding: 0 0.5rem;
  border-radius: 10px;
  color: ${(props) =>
    props.selected ? 'var(--exact-white)' : 'rgba(0,0,0,0.6)'};
  border: ${(props) => (props.disabled ? '1px dotted rgba(0,0,0,0.6)' : '0')};
  background-color: ${(props) =>
    props.selected ? green : props.disabled ? 'white' : `${lightGray}`};
  margin: 3px;
`;

export const RemoveIcon = styled(Icon)`
  cursor: pointer;
  float: right;
  font-size: 0.8rem;
  line-height: 2rem;
  padding-right: 0.5rem;
`;

export const ItemList = styled('ul')`
  display: block;
  position: absolute;
  top: 100%;
  right: 0;
  transition: all 0.2s ease-in;
  max-height: 200px;
  width: 100%;
  background-color: var(--exact-white);
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  overflow-y: auto;
  overflow-y: overlay;
  margin: 5px 0 0;
  z-index: 10001;
`;

export const Item = styled('li')`
  padding: 0.5rem;
  &:hover {
    background-color: ${lightGray};
    cursor: pointer;
  }
`;
